import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styles from "./styles.module.scss";
const Eyebrow = ({ children, color = "#333", opacity = 0.7, fontWeight, fontSize }) => (_jsx("span", { style: { color, opacity, fontWeight, fontSize }, className: styles.eyebrow, children: children }));
export default Eyebrow;
